import Forgot from "../pages/auth/Forgot.jsx";
import Login from "../pages/auth/Login.jsx";
import Otp from "../pages/auth/Otp.jsx";
import Register from "../pages/auth/Register.jsx";
import ResetPassword from "../pages/auth/ResetPassword.jsx";
import AdminLogin from "../pages/auth/AdminLogin.jsx";
import TFAuthenticator from "../pages/auth/TFAuthenticator.jsx";
import Communication from "../pages/communication/Communication.jsx";
import Dashboard from "../pages/dashboard/Dashboard.jsx";
import Trash from "../pages/documents/components/Trash.jsx";
import Documents from "../pages/documents/Documents.jsx";
// import CreateFiles from "../pages/files/components/CreateFiles.jsx";
import QuestionAnswerFlow from "../pages/files/components/QuestionAnswerFlow.jsx";
import Files from "../pages/files/Files.jsx";
import Payments from "../pages/payments/Payments.jsx";
import About from "../pages/public/About.jsx";
import Contact from "../pages/public/Contact.jsx";
import PrivacyPolicy from "../pages/public/PrivacyPolicy.jsx";
import Settings from "../pages/settings/Settings.jsx";
import PaymentVerification from "../services/stripe/PaymentVerification.jsx";
import SignatureReport from "../pages/signature/SignatureReport.jsx"
import Activity from "../pages/activity/Activity.jsx";
import Signature from "../pages/dashboard/components/Signature.jsx";
import SignPdfForMobile from "../pages/dashboard/components/SignPdfForMobile.jsx";
import Success from "../pages/public/Success.jsx";
import ReviewSubmittedFile from "../pages/files/components/ReviewSubmittedFile.jsx";
import BookKeeping from "../pages/bookKeeping/BookKeeping.jsx";
import BookKeepingDetails from "../pages/bookKeeping/components/BookKeepingDetails.jsx";
import PayRoll from "../pages/payroll/PayRoll.jsx";
import ViewPayRoll from "../pages/payroll/ViewPayRoll.jsx";
import ViewPayrollHistory from "../pages/payroll/ViewPayrollHistory.jsx";

export const initialRoutes = () => {
  const routes = [
    // ============ Auth ===============
    { path: "/login", type: "auth", component: Login, title: "Login" },
    { path: "/register", type: "auth", component: Register, title: "Register" },
    { path: "/otp", type: "auth", component: Otp, title: "Otp" },
    {
      path: "/authentication",
      type: "auth",
      component: TFAuthenticator,
      title: "Authentication",
    },
    {
      path: "/forget_password",
      type: "auth",
      component: Forgot,
      title: "ForgotPassword",
    },
    {
      path: "/change_password/:token",
      type: "auth",
      component: ResetPassword,
      title: "ResetPassword",
    },

    // ============ Public =============
    { path: "/admin_login", type: "public", component: AdminLogin },
    { path: "/sign_pdf/mobile/:id", type: "public", component: SignPdfForMobile },
    { path: "/success", type: "public", component: Success },
    { path: "/about", type: "public", component: About },
    { path: "/contact", type: "public", component: Contact },
    { path: "/privacy_policy", type: "public", component: PrivacyPolicy },

    // ============ Privet ==============
    {
      path: "/dashboard",
      type: "private",
      component: Dashboard,
      title: "Dashboard",
    },
    { path: "/", type: "private", component: Dashboard, title: "Dashboard" },
    {
      path: "/document",
      type: "private",
      component: Documents,
      title: "Document",
    },
    {
      path: "/documents_trash",
      type: "private",
      component: Trash,
      title: "Trash",
    },
    { path: "/files", type: "private", component: Files, title: "Files" },
    // { path: "/create_files", type: "private", component: CreateFiles, title: "Files" },
    {
      path: "/file/:id",
      type: "private",
      component: QuestionAnswerFlow,
      title: "Files",
    },
    {
      path: "/file/:id/review_answer",
      type: "private",
      component: ReviewSubmittedFile,
      title: "Files",
    },
    { path: "/chat", type: "private", component: Communication, title: "Chat" },
    { path: "/activity", type: "private", component: Activity, title: "Activity" },
    { path: "/signature", type: "private", component: SignatureReport, title: "Signature" },
    {
      path: "/settings",
      type: "private",
      component: Settings,
      title: "settings",
    },
    {
      path: "/payments",
      type: "private",
      component: Payments,
      title: "Payments Report",
    },
    {
      path: "/settings",
      type: "private",
      component: Settings,
      title: "settings",
    },
    {
      path: "/payroll",
      type: "private",
      component: PayRoll,
      title: "Payroll",
    },
    {
      path: "/payroll/view_payroll",
      type: "private",
      component: ViewPayRoll,
      title: "View Payroll",
    },
     {
      path: "/payroll/:id",
      type: "private",
      component: ViewPayrollHistory,
      title: "View Payroll",
    },
    {
      path: "/book_keeping",
      type: "private",
      component: BookKeeping,
      title: "book keeping",
    },
    {
      path: "/book_keeping/:id",
      type: "private",
      component: BookKeepingDetails,
      title: "book keeping",
    },
    {
      path: "/payment_verification/:id",
      type: "private",
      component: PaymentVerification,
      title: "Payment Verification",
    },
    {
      path: "/sign_pdf/:id",
      type: "private",
      component: Signature,
      title: "Signature"
    }
  ];
  return routes;
};
